var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "codeignitor-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#f77c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#f77c7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "codeigniter",
    transform: "translate(255.669 -540.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M-220.526,577.568a1.3,1.3,0,0,1-2.33.871c-.922-1.306.026-2.689.154-4.046a4.912,4.912,0,0,0-1.152-3.483.379.379,0,0,0-.666.231,5.168,5.168,0,0,1-1.152,2.51c-.691.845-1.536,1.562-2.279,2.33a20.747,20.747,0,0,0-2.279,2.689,8.587,8.587,0,0,0-1.562,6.863,6.079,6.079,0,0,0,2.663,3.662.373.373,0,0,0,.512-.512,3.323,3.323,0,0,1-.589-1.793,4.326,4.326,0,0,1,1.178-2.868.372.372,0,0,1,.64.2,1.06,1.06,0,0,0,.23.589,1.281,1.281,0,0,0,1.306.538,1.436,1.436,0,0,0,.512-2.433,3.257,3.257,0,0,1-1.05-2.817,3.211,3.211,0,0,1,.23-.64.362.362,0,0,1,.666.051,3.634,3.634,0,0,0,1.127,1.332,29.584,29.584,0,0,1,3.073,2.254,4.5,4.5,0,0,1,1.562,3.713,3.457,3.457,0,0,1-.615,1.69.371.371,0,0,0,.512.512,6.471,6.471,0,0,0,3.175-5.275,7.08,7.08,0,0,0-3.867-6.172",
    transform: "translate(-5.655 -9.876)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Codeigniter-2",
    "data-name": "Codeigniter",
    transform: "translate(-237.628 557.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    d: "M-220.274,579.8c3.175-.691,6.786-3.611,6.786-7.273s-3.329-5.813-4.84-6.786a1.4,1.4,0,0,1-1.306,1.46h-.128a1.511,1.511,0,0,1-1.46-1.46c0-1.844.487-1.536.487-3.406,0-1.844-.2-2.766-2.433-4.84.794,3.944-2.612,5.531-5.327,8.246s-3.406,5.1-3.406,6.786a6.88,6.88,0,0,0,5.813,7.273c-2.023-1.869-2.433-2.843-2.433-3.892a5.479,5.479,0,0,1,2.433-3.892c-.973,2.458.64,2.919,1.46,2.919s1.46-.717,1.46-1.946c0-1.2-1.946-1.946-1.946-3.406a3.737,3.737,0,0,1,.973-2.433s-.333.973.973,1.946c1.28.973,5.813,3.227,5.813,5.813C-217.38,577.526-218.328,578.4-220.274,579.8Z",
    transform: "translate(231.9 -557.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 1.997,
    cy: 1.997,
    r: 1.997,
    transform: "translate(-239.6 558.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 0.717,
    cy: 0.717,
    r: 0.717,
    transform: "translate(-233.889 560.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 1.536,
    cy: 1.536,
    r: 1.536,
    transform: "translate(-219.216 577.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 0.845,
    cy: 0.845,
    r: 0.845,
    transform: "translate(-223.39 560.88)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.0c21bf3a1bd99546e2f90b4b26dfd143.svg";
export { ForwardRef as ReactComponent };